<template>
  <div class="d-block">
    <h3 class="pt-0 mt-0 pb-0">
      {{ $t("viewAMCrosses.title") }}
      <v-btn
        color="success"
        class="ml-1 green-shadow"
        x-small
        fab
        max-width="26"
        max-height="26"
        @click.stop="isVisibleDialog = true"
        :title="$t('viewAMCrosses.add_cross')"
      >
        <v-icon x-small>$plus</v-icon>
      </v-btn>
    </h3>
    <v-toolbar elevation="0" dense rounded class="mt-3">
      <v-toolbar-items>
        <v-btn small text :to="{ name: 'am-search' }" exact>{{
          $t("navigation.am_search")
        }}</v-btn>
        <v-btn small text :to="{ name: 'am-crosses' }">
          {{ $t("navigation.crosses") }}</v-btn
        >
        <v-btn small text :to="{ name: 'am-aliases' }">
          {{ $t("navigation.aliases") }}</v-btn
        >
      </v-toolbar-items>
    </v-toolbar>
    <v-layout class="pa-3 pt-0">
      <v-flex xs12>
        <v-row>
          <v-col
            cols="12"
            class="d-flex justify-end text-right py-2 pb-1 pr-0"
            sm="12"
            md="12"
          >
            <v-spacer></v-spacer>
            <v-btn
              color="warning"
              class="mt-3 mb-3 align-content-end elevation-0 mr-2"
              @click="restoreSettings"
            >
              {{ $t("viewAMCrosses.restore_default_settings") }}
            </v-btn>
            <v-btn
              :disabled="csvIsLoading"
              :loading="csvIsLoading"
              color="success"
              class="mx-0 mt-3 mb-3 align-content-end elevation-0"
              @click="$refs.uploadCSVinput.click()"
            >
              {{ $t("viewAMCrosses.add_cross_batch") }}
            </v-btn>
            <input
              v-show="false"
              ref="uploadCSVinput"
              :key="uploadCsvKey"
              type="file"
              accept=".csv"
              @change="uploadCSVCrossess"
            />
          </v-col>
        </v-row>
      </v-flex>
    </v-layout>
    <v-row class="px-3">
      <v-col class="pa-0">
        <div v-if="uploadedCSVFiles">
          <v-data-table
            :headers="tableHeader"
            :items="uploadedCSVFiles"
            class="elevation-0 mb-3"
          >
            <template v-slot:items="props">
              <td class="text-xs-left">{{ props.item.file }}</td>
              <td class="text-xs-left">{{ props.item.status }}</td>
              <td class="text-xs-left">{{ props.item.parse_error }}</td>
              <td class="text-xs-left">{{ props.item.added }}</td>
              <td class="text-xs-left">{{ props.item.exists }}</td>
              <td class="text-xs-left">{{ props.item.total_lines }}</td>
              <td class="text-xs-left">{{ props.item.updated }}</td>
            </template>
            <template v-slot:no-data>
              {{ $t("common.no_data_available") }}
            </template>
            <template v-slot:no-results>
              {{ $t("common.no_data_available") }}
            </template>
          </v-data-table>
        </div>
      </v-col>
    </v-row>
    <v-row class="px-3">
      <v-col class="pa-0">
        <h3 class="primary--text">
          {{ $t("viewAMCrosses.file_with_cross_references") }}
        </h3>
        <p>
          {{ $t("viewAMCrosses.csv_crosses_file_should_be") }}
        </p>
        <ul class="pb-1 d-flex">
          <li class="mr-5">
            {{ $t("viewAMCrosses.csv_crosses_file_charset") }}
          </li>
          <li class="ml-5 mr-5">
            {{ $t("viewAMCrosses.csv_crosses_file_field_delimiter") }}
          </li>
          <li class="ml-5 mr-5">
            {{ $t("viewAMCrosses.csv_crosses_file_string_delimiter") }}
          </li>
        </ul>
        <p class="pt-4">{{ $t("viewAMCrosses.csv_crosses_file_first_row") }}</p>
        <v-btn
          color="primary"
          class="mx-0"
          target="_blank"
          elevation="0"
          href="https://levam.net/files/levam_crosses_example.csv"
        >
          {{ $t("viewAMCrosses.download_CSV_file_example") }}
        </v-btn>

        <v-dialog
          v-model="isVisibleDialog"
          persistent
          scrollable
          max-width="800px"
        >
          <v-card>
            <v-card-actions class="px-3">
              <h3>{{ $t("viewAMCrosses.add_cross_dlg_title") }}</h3>
            </v-card-actions>
            <v-divider></v-divider>
            <v-card-text class="ma-0 pa-0">
              <div class="pa-3">
                <v-form ref="addCrossForm">
                  <h3>{{ $t("viewAMCrosses.Part_for_cross_reference") }}:</h3>
                  <v-row>
                    <v-col cols="6">
                      <v-text-field
                        :label="$t('viewAMCrosses.part_number')"
                        :placeholder="$t('viewAMCrosses.enter_part_number')"
                        autocomplete="off"
                        validate-on-blur
                        hide-details
                        clearable
                        outlined
                        v-model="newCross.for_part_number"
                        :error-messages="newCrossValidate['for_part_number']"
                        @blur="$v.newCross.for_part_number.$touch()"
                        @input="$v.newCross.for_part_number.$touch()"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="6">
                      <v-text-field
                        :label="$t('viewAMCrosses.Brand')"
                        :placeholder="$t('viewAMCrosses.enter_brand_name')"
                        :error-messages="newCrossValidate['for_brand_name']"
                        autocomplete="off"
                        hide-details
                        clearable
                        outlined
                        v-model="newCross.for_brand_name"
                        @blur="$v.newCross.for_brand_name.$touch()"
                        @input="$v.newCross.for_brand_name.$touch()"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-divider class="my-3"></v-divider>
                  <h3>{{ $t("viewAMCrosses.Cross_reference_to") }}:</h3>
                  <v-row>
                    <v-col cols="4">
                      <v-text-field
                        v-model="newCross.part_number"
                        :label="$t('viewAMCrosses.part_number')"
                        :placeholder="$t('viewAMCrosses.enter_part_number')"
                        :error-messages="newCrossValidate['part_number']"
                        autocomplete="off"
                        hide-details
                        validate-on-blur
                        clearable
                        outlined
                        @blur="$v.newCross.part_number.$touch()"
                        @input="$v.newCross.part_number.$touch()"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="4">
                      <v-text-field
                        v-model="newCross.brand_name"
                        :label="$t('viewAMCrosses.Brand')"
                        :placeholder="$t('viewAMCrosses.enter_brand_name')"
                        :error-messages="newCrossValidate['brand_name']"
                        autocomplete="off"
                        hide-details
                        validate-on-blur
                        clearable
                        outlined
                        @blur="$v.newCross.brand_name.$touch()"
                        @input="$v.newCross.brand_name.$touch()"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="4">
                      <v-text-field
                        :label="$t('viewAMCrosses.part_name')"
                        :placeholder="$t('viewAMCrosses.enter_part_name')"
                        autocomplete="off"
                        hide-details
                        clearable
                        outlined
                        v-model="newCross.part_name"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-btn
                      color="success"
                      elevation="0"
                      outlined
                      class="ml-3 mt-0 mb-3 align-content-end"
                      @click="$refs.uploadImageInput.click()"
                      v-if="!newCross.image_file_name"
                    >
                      <v-icon small left>mdi-attachment</v-icon>
                      {{ $t("common.picture") }}
                    </v-btn>
                    <div class="ml-3" v-else>
                      <v-icon small left>mdi-attachment</v-icon
                      >{{ newCross.image_file_name
                      }}<v-btn
                        @click="
                          newCross.image_file_name = null;
                          newCross.image = null;
                          uploadImageKey++;
                        "
                        icon
                        small
                        text
                        ><v-icon>mdi-close-circle</v-icon></v-btn
                      >
                    </div>
                    <input
                      :key="uploadImageKey"
                      v-show="false"
                      ref="uploadImageInput"
                      type="file"
                      @change="uploadImage"
                      accept=".png,.jpg"
                    />
                  </v-row>
                </v-form>
              </div>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions class="px-3">
              <v-spacer></v-spacer>
              <v-btn
                color="danger"
                elevation="0"
                class="mr-3 white--text"
                @click="
                  isVisibleDialog = false;
                  uploadImageKey++;
                  newCross.image_file_name = null;
                  newCross.image = null;
                "
              >
                {{ $t("common.cancel") }}
              </v-btn>
              <v-btn color="primary" class="mr-0" elevation="0" @click="addNew">
                {{ $t("common.save") }}
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { required } from "vuelidate/lib/validators";
import { mapFields } from "vuex-map-fields";

export default {
  data: () => ({
    uploadImageKey: 0,
    uploadCsvKey: 0,
    isVisibleDialog: false,
    table: {
      options: {
        "items-per-page": [10000, 25, 50],
        "next-icon": "navigate_next",
        "prev-icon": "navigate_before",
      },
    },
  }),
  validations() {
    return {
      newCross: {
        for_brand_name: { required },
        for_part_number: { required },
        part_number: { required },
        brand_name: { required },
      },
    };
  },
  mounted() {
    this.$store.dispatch("am_crosses/listuploadedCSV");
  },
  computed: {
    ...mapFields("am_crosses", [
      "csvIsLoading",
      "uploadedCSVFiles",
      "newCross",
    ]),
    newCrossValidate() {
      const errors = [];

      errors["for_brand_name"] = [];
      if (this.$v.newCross.for_brand_name.$dirty) {
        !this.$v.newCross.for_brand_name.required &&
          errors["for_brand_name"].push(
            this.$t("form.validationErrors.field_is_required")
          );
      }

      errors["for_part_number"] = [];
      if (this.$v.newCross.for_part_number.$dirty) {
        !this.$v.newCross.for_part_number.required &&
          errors["for_part_number"].push(
            this.$t("form.validationErrors.field_is_required")
          );
      }

      errors["part_number"] = [];
      if (this.$v.newCross.part_number.$dirty) {
        !this.$v.newCross.part_number.required &&
          errors["part_number"].push(
            this.$t("form.validationErrors.field_is_required")
          );
      }

      errors["brand_name"] = [];
      if (this.$v.newCross.brand_name.$dirty) {
        !this.$v.newCross.brand_name.required &&
          errors["brand_name"].push(
            this.$t("form.validationErrors.field_is_required")
          );
      }
      return errors;
    },
    tableHeader() {
      return [
        { text: this.$t("common.file_name"), value: "file", sortable: true },
        { text: this.$t("common.status"), value: "status", sortable: true },
        {
          text: this.$t("viewAMCrosses.parse_error"),
          value: "parse_error",
          sortable: false,
        },
        {
          text: this.$t("viewAMCrosses.added"),
          value: "added",
          sortable: false,
        },
        {
          text: this.$t("viewAMCrosses.exists"),
          value: "exists",
          sortable: false,
        },
        {
          text: this.$t("viewAMCrosses.total_lines"),
          value: "total_lines",
          sortable: false,
        },
        {
          text: this.$t("viewAMCrosses.status_change_date"),
          value: "updated",
          sortable: true,
        },
      ];
    },
  },
  methods: {
    uploadImage() {
      let sizeInMB = (
        this.$refs.uploadImageInput.files[0].size /
        (1024 * 1024)
      ).toFixed(2);
      if (sizeInMB > 2) {
        this.$error(
          this.$t("form.validationErrors.must_be_less_than_or_equal_to", [
            "2 Mb",
          ])
        );
      } else {
        this.newCross.image = this.$refs.uploadImageInput.files[0];
        this.newCross.image_file_name =
          this.$refs.uploadImageInput.files[0].name;
      }
    },
    uploadCSVCrossess() {
      this.$store
        .dispatch("am_crosses/uploadCSVCrossess", {
          file: this.$refs.uploadCSVinput.files[0],
        })
        .then((response) => {
          if (response === "success") {
            this.$inform(this.$t("common.operation_success"));
          }
          this.$refs.uploadCSVinput.value = null;
          this.uploadCsvKey++;
        })
        .catch(() => {
          this.$refs.uploadCSVinput.value = null;
          this.uploadCsvKey++;
        });
    },
    addNew() {
      this.$v.$touch();
      if (this.$v.$invalid) return;
      this.$store
        .dispatch("am_crosses/addNew")
        .then((response) => {
          if (response === "success") {
            this.isVisibleDialog = false;
            this.$v.$reset();
            this.$inform(this.$t("common.operation_success"));
          }
        })
        .finally(() => {
          this.uploadImageKey++;
        });
    },
    restoreSettings() {
      this.$store.dispatch("am_crosses/restoreSettings").then((response) => {
        if (response == "success") {
          this.$inform(this.$t("viewAMCrosses.success_restored_default"));
        }
      });
    },
  },
};
</script>

<style>
.replacementImageWrap {
  float: left;
  margin-right: 10px;
}
.replacementImageWrap img {
  height: 100px;
  margin-top: 5px;
}
.isUserCross {
  color: green;
}
.isExcludedCross {
  color: gray;
  text-decoration: line-through;
}
</style>
